<div id="breadcrumb-navigation" class="breadcrumb">
  {{ labels.administration }}
  <a
    id="parameters-breadcrumb-link"
    class="breadcrumb-link selected"
    [routerLink]="['/wapi/admin/parameters']"
  >
    &nbsp;>&nbsp;{{ labels.parameters }}
  </a>
</div>

<br /><br />

<div id="parameters-main-container" class="container">
  <mat-card id="parameters-card">
    <div id="parameters-header" class="header-options">
      <div id="parameters-title" class="title">
        <div class="title-wrapper">
          <h1 class="main-title">{{ labels.parameters }}</h1>
        </div>
      </div>
      <div class="header-actions">
        <button
          mat-raised-button
          class="filter-button"
          (click)="toggleSearch()"
          matTooltip="Filtro"
        >
          <mat-icon>filter_list</mat-icon>
          FILTRO
        </button>
        <button
          mat-raised-button
          color="primary"
          class="create-button"
          (click)="openModal('parent')"
          matTooltip="{{ labels.createParameter }}"
        >
          <mat-icon>add</mat-icon>
          {{ labels.createParameter }}
        </button>
      </div>
    </div>

    <!-- Search Panel -->
    @if (showSearchPanel) {
      <div class="search-panel">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Buscar parámetros</mat-label>
          <input
            matInput
            [(ngModel)]="searchQuery"
            (input)="searchParameters($any($event.target).value)"
            placeholder="Buscar por nombre o código..."
          />
          <mat-icon matSuffix>search</mat-icon>
          @if (searchQuery) {
            <button matSuffix mat-icon-button (click)="clearSearch()">
              <mat-icon>clear</mat-icon>
            </button>
          }
        </mat-form-field>
        <button mat-icon-button class="close-search-button" (click)="toggleSearch()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }

    <div class="parameter-card">
      <div class="parameter-header"></div>
      <div class="parameter-selection-row">
        <mat-form-field appearance="outline" class="parameter-select">
          <mat-label>{{ labels.selectParameter }}</mat-label>
          <mat-select (selectionChange)="onParameterSelectionChange($event.value)">
            <mat-option [value]="null">{{ labels.notSelected }}</mat-option>
            @for (
              parameter of displayParameters$ | async;
              track trackByParameterId(parameter.idParametro, parameter)
            ) {
              <mat-option [value]="parameter">{{ parameter.vcNombre }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <button
          mat-icon-button
          class="create-button"
          (click)="openModal('parent')"
          matTooltip="{{ labels.createParameter }}"
        >
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>

    <br />

    <div id="parameters-table-section" class="table-container">
      @if (loading$ | async) {
        <div class="loading-container">
          <mat-spinner diameter="50"></mat-spinner>
          <p>Loading parameters...</p>
        </div>
      } @else if (error$ | async) {
        <div class="error-container">
          <p class="error-message">{{ error$ | async }}</p>
          <button mat-raised-button color="primary" (click)="loadParameters()">Retry</button>
        </div>
      } @else if (selectedParameter$ | async) {
        @if (selectedParameter$ | async; as selectedParameter) {
          <h2 id="selected-parameter-title" class="parameter-title">
            {{ selectedParameter.vcNombre }}
            <button
              id="edit-parameter-button"
              mat-icon-button
              class="edit-button"
              matTooltip="Edit"
              (click)="openModal('parent')"
            >
              <mat-icon>edit</mat-icon>
            </button>
            <button
              id="view-parameter-button"
              mat-icon-button
              class="view-button"
              matTooltip="View"
              (click)="viewDetail(selectedParameter, true)"
            >
              <mat-icon>visibility</mat-icon>
            </button>
          </h2>
        }

        @if ((parameterDetailList$ | async)?.length ?? 0 > 0) {
          <div class="table-wrapper">
            <table
              id="parameters-detail-table"
              mat-table
              [dataSource]="(parameterDetailList$ | async) ?? []"
              class="mat-elevation-z8 full-width-table styled-table"
              matSort
            >
              <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef>{{ labels.tableCode }}</th>
                <td mat-cell *matCellDef="let element">{{ element.dCodigoIterno }}</td>
              </ng-container>

              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>{{ labels.tableName }}</th>
                <td mat-cell *matCellDef="let element">{{ element.vcNombre }}</td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>{{ labels.tableStatus }}</th>
                <td mat-cell *matCellDef="let element">
                  <span [class]="element.bEstado ? 'status-active' : 'status-inactive'">
                    {{ element.bEstado ? 'Activo' : 'Inactivo' }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>{{ labels.tableActions }}</th>
                <td mat-cell *matCellDef="let element">
                  <div class="action-buttons">
                    <button
                      [id]="'view-detail-button-' + element.idParametroDetalle"
                      mat-icon-button
                      class="view-button"
                      matTooltip="Ver"
                      (click)="viewDetail(element, false)"
                    >
                      <mat-icon>visibility</mat-icon>
                    </button>
                    <button
                      [id]="'edit-detail-button-' + element.idParametroDetalle"
                      mat-icon-button
                      class="edit-button"
                      matTooltip="Editar"
                      (click)="openModal(element)"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button
                      [id]="'toggle-detail-button-' + element.idParametroDetalle"
                      mat-icon-button
                      class="toggle-button"
                      [matTooltip]="element.bEstado ? 'Desactivar' : 'Activar'"
                      (click)="onStatusChange(element, !element.bEstado)"
                    >
                      <mat-icon>{{ element.bEstado ? 'toggle_on' : 'toggle_off' }}</mat-icon>
                    </button>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: tableColumns" class="parameter-row"></tr>
            </table>

            <!-- Paginador -->
            <mat-paginator
              #paginator
              [pageSize]="pageSize"
              [pageSizeOptions]="pageSizeOptions"
              [showFirstLastButtons]="true"
              [length]="(parameterDetailList$ | async)?.length || 0"
              aria-label="Seleccionar página de parámetros"
            >
            </mat-paginator>
          </div>
        }

        @if ((parameterDetailList$ | async)?.length === 0 && (selectedParameter$ | async)) {
          <p id="no-parameters-message" class="no-data-text">{{ labels.noData }}</p>
        }
      }
    </div>
  </mat-card>
</div>

<ng-template #createParameterModal>
  <h2 id="parameter-modal-title" mat-dialog-title>
    {{
      parameterDetailInEdit
        ? labels.editSubParameter
        : isCreatingDetail
          ? labels.createSubParameter
          : labels.createParameter
    }}
  </h2>

  <mat-dialog-content id="parameter-modal-content" class="modal-content">
    <form id="parameter-form" [formGroup]="parameterForm">
      @if (isCreatingDetail) {
        <mat-form-field id="parent-parameter-field" appearance="outline" class="full-width">
          <mat-label>{{ labels.parameter }}</mat-label>
          <input matInput [value]="(selectedParameter$ | async)?.vcNombre" disabled />
        </mat-form-field>
      }

      <mat-form-field id="code-field" appearance="outline" class="full-width">
        <mat-label>{{ labels.code }}</mat-label>
        <input matInput formControlName="code" />
        @if (parameterForm.get('code')?.invalid) {
          <mat-error>{{ labels.requiredField }}</mat-error>
        }
      </mat-form-field>

      <mat-form-field id="name-field" appearance="outline" class="full-width">
        <mat-label>{{ labels.name }}</mat-label>
        <input matInput formControlName="name" />
        @if (parameterForm.get('name')?.invalid) {
          <mat-error>{{ labels.requiredField }}</mat-error>
        }
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions id="parameter-modal-actions" align="end">
    <button
      id="save-parameter-button"
      mat-button
      mat-raised-button
      color="primary"
      [disabled]="parameterForm.invalid"
      [ngClass]="{ 'custom-save-button': parameterForm.valid }"
      (click)="saveParameter()"
    >
      {{ labels.save }}
    </button>
    <button id="cancel-parameter-button" mat-button color="accent" (click)="closeModal()">
      {{ labels.cancel }}
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #detailModal>
  <div class="detail-modal-container">
    <!-- Header -->
    <div class="detail-modal-header">
      <h2 id="detail-modal-title" mat-dialog-title>Detalle de Parámetro</h2>
    </div>

    <!-- Content -->
    <mat-dialog-content id="detail-modal-content" class="detail-modal-content">
      <div class="detail-info">
        @if (isParentDetail) {
          <div class="detail-row">
            <span class="detail-label">Nombre:</span>
            <span class="detail-value">{{ detailBeingViewed?.vcNombre }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Código:</span>
            <span class="detail-value code-value">{{ detailBeingViewed?.vcCodigoInterno }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Estado:</span>
            <span class="detail-value">
              <span
                class="status-badge"
                [class]="detailBeingViewed?.bEstado ? 'status-active' : 'status-inactive'"
              >
                {{ detailBeingViewed?.bEstado ? 'Activo' : 'Inactivo' }}
              </span>
            </span>
          </div>
        }

        @if (!isParentDetail) {
          <div class="detail-row">
            <span class="detail-label">Nombre:</span>
            <span class="detail-value">{{ detailBeingViewed?.vcNombre }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Código:</span>
            <span class="detail-value code-value">{{ detailBeingViewed?.vcCodigoInterno }}</span>
          </div>
        }
      </div>
    </mat-dialog-content>

    <!-- Actions -->
    <mat-dialog-actions id="detail-modal-actions" align="end" class="detail-modal-actions">
      <button id="close-detail-button" mat-button mat-dialog-close class="close-detail-button">
        {{ labels.close }}
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>
